/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveCajaComprobante } from "../../../project/services/CajaService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  descripcion: "",
  idTipoComprobante: "",
  numeroComprobante: "",
  idProveedor: "",
  importe: "",
  motivoAnulacion: "",
};

const nameItemText = "Comprobante de Gastos de Caja";
const itemGender = "M";
//
// ########################################################################### 
//
const CajaComprobanteDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
  tiposComprobante,
  proveedores,
  idCaja
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  // Parsea string a número: 24.00, 24533,00, 24.533,00, 24,533.00, 42000
  const parseImporte = (val) => {
    if (val === "" || val == null) return 0;
    const str = String(val).trim();
    if (str === "") return 0;
    const lastDot = str.lastIndexOf(".");
    const lastComma = str.lastIndexOf(",");
    const lastSep = Math.max(lastDot, lastComma);
    let integerPart, decimalPart;
    if (lastSep >= 0) {
      integerPart = str.substring(0, lastSep).replace(/[.,]/g, "");
      decimalPart = str.substring(lastSep + 1);
    } else {
      integerPart = str.replace(/[.,]/g, "");
      decimalPart = "";
    }
    const full = decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
    const num = parseFloat(full);
    return isNaN(num) ? 0 : num;
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let finalValue = type === "checkbox" ? e.target.checked : value;
    if (name === "importe") {
      // Guarda el texto tal cual para permitir escribir 24.50, 24,533.00, etc.
      finalValue = String(value).replace(/[^\d.,]/g, "");
    }
    setItemCrudLocal({
      ...itemCrudLocal,
      [name]: finalValue,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update" || actionCrud === "delete") {

      if (itemCrudLocal.idTipoComprobante === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Tipo de Comprobante",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.numeroComprobante === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un N° de Comprobante",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.idProveedor === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Tipo de Proveedor",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción",
        });
        setShowMessage(true);
        return;
      }

      const importeNum = parseImporte(itemCrudLocal.importe);
      if (isNaN(importeNum) || importeNum <= 0) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar un importe válido",
        });
        setShowMessage(true);
        return;
      }
      if (actionCrud === "delete" && itemCrudLocal.motivoAnulacion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el motivo de anulación",
        });
        setShowMessage(true);
        return;
      }

    }
    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {
    let _itemCrud = {
      idCaja: idCaja,
      idTipoComprobante: itemCrudLocal.idTipoComprobante,
      idProveedor: itemCrudLocal.idProveedor,
      numeroComprobante: itemCrudLocal.numeroComprobante,
      descripcion: itemCrudLocal.descripcion,
      importe: parseImporte(itemCrudLocal.importe),
      motivoAnulacion: itemCrudLocal.motivoAnulacion,

    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }
    setIsDoingSomething(true);
    const response = await saveCajaComprobante(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "view"
                ? "Ver"
                : actionCrud === "delete"
                  ? "Anular"
                  : actionCrud === "enable"
                    ? "Habilitando"
                    : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>

              <Autocomplete
                id="idTipoComprobante"
                options={tiposComprobante}
                getOptionLabel={(option) => option.descripcion}
                value={tiposComprobante.find(option => option.id === itemCrudLocal.idTipoComprobante) || null}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: 'idTipoComprobante',
                      value: newValue ? newValue.id : null,
                    }
                  });
                }}
                disabled={actionCrud === "view" || actionCrud === "delete"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de Comprobante"
                    size="small"
                  />
                )}
                ListboxProps={{ style: { maxHeight: "300px" } }}
              />
            </Grid>


            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="numeroComprobante"
                label="N° de Comprobante"
                variant="outlined"
                size="small"
                name="numeroComprobante"
                value={itemCrudLocal.numeroComprobante}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "delete"}
              />
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                id="idTipoComprobante"
                options={proveedores}
                getOptionLabel={(option) => option.descripcion}
                value={proveedores.find(option => option.id === itemCrudLocal.idProveedor) || null}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: 'idProveedor',
                      value: newValue ? newValue.id : null,
                    }
                  });
                }}
                disabled={actionCrud === "view" || actionCrud === "delete"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Proveedor"
                    size="small"
                  />
                )}
                ListboxProps={{ style: { maxHeight: "300px" } }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "delete"}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  inputMode: "decimal",
                  pattern: "[0-9.,]*",
                }}
                id="importe"
                label="Importe"
                variant="outlined"
                size="small"
                name="importe"
                value={itemCrudLocal.importe}
                onChange={handleChange}
                disabled={actionCrud === "view" || actionCrud === "delete"}
              />
            </Grid>

            {actionCrud === "view" && itemCrud.motivoAnulacion !== "" && (
              <Grid item xs={12}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="motivoAnulacion"
                  label="Motivo de Anulación"
                  variant="outlined"
                  size="small"
                  name="motivoAnulacion"
                  value={itemCrudLocal.motivoAnulacion}
                  onChange={handleChange}
                  disabled={actionCrud === "view"}
                />
              </Grid>
            )}

            {actionCrud === "delete" && (
              <Grid item xs={12}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="motivoAnulacion"
                  label="Motivo de Anulación"
                  variant="outlined"
                  size="small"
                  name="motivoAnulacion"
                  value={itemCrudLocal.motivoAnulacion}
                  onChange={handleChange}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                {actionCrud !== "view" && (
                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleSave}
                    disabled={actionCrud === "view"}
                    startIcon={
                      actionCrud === "disable" ? (
                        <RemoveCircleOutlineIcon />
                      ) : actionCrud === "enable" ? (
                        <AddCircleOutlineIcon />
                      ) : (
                        <SaveIcon />
                      )
                    }
                  >
                    {actionCrud === "disable"
                      ? "Deshabilitar"
                      : actionCrud === "enable"
                        ? "Habilitar"
                        : "Guardar"}
                  </Button>
                )}
                <Button
                  variant="outlined"
                  onClick={handleCloseDialog}
                >
                  {actionCrud === "view" ? "Cerrar" : "Cancelar"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CajaComprobanteDialog;